@if (loginStateService.loggedIn && holderService.holder.change_log.log.length > 0) {
  <div id="change-log">
    <div id="outer-change-log">
      <img src="assets/img/arrow.png" style="height:30px;width:30px;" />
      <p>{{holderService.holder.change_log.log.length}}
        @if (holderService.holder.change_log.log.length === 1) {
          <span>{{strings['CHANGE']}}</span>
        }
        @if (holderService.holder.change_log.log.length > 1) {
          <span>{{strings['CHANGES']}}</span>
        }
      </p>
    </div>
    @for (change of holderService.holder.change_log.log; track change) {
      <div class="inner-change-log">
        - {{strings[change.action]}} {{strings[change.constant].toLowerCase()}} {{change.object.label}}
      </div>
    }
    <div id="reset" (click)="reset()">reset</div>
  </div>
}
